import clsx from 'clsx';
import styles from './Badge.module.scss';
import type {HTMLAttributes} from 'react';

export type BadgeVariant = 'lavender' | 'neutral';

/** `compact` — вертикальные отступы как у корп. модалки; у `lavender` не влияет */
export type BadgeDensity = 'default' | 'compact';

export type BadgeProps = Omit<HTMLAttributes<HTMLSpanElement>, 'onClick'> & {
    variant?: BadgeVariant;
    density?: BadgeDensity;
};

/** Статичная метка (`span`). Не интерактивен; для действий — кнопка или ссылка рядом/внутри родителя. */
export const Badge = ({
    variant = 'lavender',
    density = 'default',
    className,
    children,
    ...rest
}: BadgeProps) => {
    const variantClass =
        variant === 'lavender'
            ? styles.BadgeLavender
            : density === 'compact'
              ? styles.BadgeNeutralCompact
              : styles.BadgeNeutral;

    return (
        <span className={clsx(styles.Badge, variantClass, className)} {...rest}>
            {children}
        </span>
    );
};
